import { Home } from "api-client/models/Home";

export enum ACTIONS {
    GET_HOME_PAGE_REQUEST = "HOME/GET_HOME_PAGE_REQUEST",
    GET_HOME_PAGE_SUCCESS = "HOME/GET_HOME_PAGE_SUCCESS",
    GET_HOME_PAGE_FAILURE = "HOME/GET_HOME_PAGE_FAILURE",
}

interface GetHomePageRequest {
    type: ACTIONS.GET_HOME_PAGE_REQUEST;
}

interface GetHomePageSuccess {
    type: ACTIONS.GET_HOME_PAGE_SUCCESS;
    payload: Home;
}

interface GetHomePageFailure {
    type: ACTIONS.GET_HOME_PAGE_FAILURE;
}

export type ActionType = GetHomePageRequest | GetHomePageSuccess | GetHomePageFailure;
